import React from 'react';
import { CheckIcon } from 'lucide-react';
export function Availability() {
  const includedServices = ['Professionele beveiligingsuitrusting', 'Directe communicatie', 'Gedetailleerde rapportages', 'Eigen vervoer', 'Flexibele inzetbaarheid', 'IT-ondersteuning & advies'];
  return <section className="py-16 md:py-20 border-b border-zinc-800" data-id="element-32">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-33">
        <h2 className="text-2xl md:text-3xl font-light mb-8 md:mb-10" data-id="element-34">
          Beveiligingsdiensten & Tarieven
        </h2>
        <div className="grid md:grid-cols-2 gap-8 md:gap-10" data-id="element-35">
          <div className="bg-zinc-900 p-6 rounded-none shadow-sm" data-id="element-36">
            <h3 className="text-xl font-medium mb-5 text-slate-300" data-id="element-37">
              Beveiligingsdiensten
            </h3>
            <div className="space-y-5 text-base" data-id="element-38">
              <div data-id="element-39">
                <div className="font-medium text-zinc-300 mb-2" data-id="element-40">
                  Werkgebied:
                </div>
                <div data-id="element-41">Zaanstreek en omgeving</div>
              </div>
              <div data-id="element-42">
                <div className="font-medium text-zinc-300 mb-2" data-id="element-43">
                  Beschikbaarheid:
                </div>
                <div data-id="element-44">Flexibel inzetbaar, in overleg te bepalen</div>
              </div>
              <div data-id="element-45">
                <div className="font-medium text-zinc-300 mb-2" data-id="element-46">
                  Aanvraagtermijn:
                </div>
                <div data-id="element-47">Bij voorkeur minimaal 48 uur van tevoren</div>
              </div>
            </div>
            <div className="mt-7 p-5 bg-black rounded-none" data-id="element-48">
              <div className="font-medium mb-3 text-slate-300" data-id="element-49">
                Type beveiligingsdiensten:
              </div>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-base" data-id="element-50">
                <li className="flex items-center gap-3" data-id="element-51">
                  <CheckIcon className="w-4 h-4 text-slate-500" data-id="element-52" />
                  <span data-id="element-53">Objectbeveiliging</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-54">
                  <CheckIcon className="w-4 h-4 text-slate-500" data-id="element-55" />
                  <span data-id="element-56">Winkelbeveiliging</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-57">
                  <CheckIcon className="w-4 h-4 text-slate-500" data-id="element-58" />
                  <span data-id="element-59">Toegangscontrole</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-60">
                  <CheckIcon className="w-4 h-4 text-slate-500" data-id="element-61" />
                  <span data-id="element-62">Evenementenbeveiliging</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="bg-zinc-900 p-6 rounded-none shadow-sm" data-id="element-63">
            <h3 className="text-xl font-medium mb-5 text-slate-300" data-id="element-64">
              Tarieven
            </h3>
            <div className="mb-7" data-id="element-65">
              <div className="text-2xl font-light text-center mb-3 p-4 border border-zinc-800 rounded-none" data-id="element-66">
                Op aanvraag
              </div>
              <p className="text-zinc-400 mt-4 text-base leading-relaxed" data-id="element-67">
                Tarieven worden bepaald op basis van type dienst, duur, tijdstip
                en specifieke vereisten. Neem contact op voor een persoonlijke
                offerte toegespitst op uw beveiligingsbehoeften.
              </p>
            </div>
            <div data-id="element-68">
              <h4 className="font-medium mb-4 border-b border-zinc-800 pb-2 text-slate-300" data-id="element-69">
                Inbegrepen bij de dienstverlening:
              </h4>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-3 text-base" data-id="element-70">
                {includedServices.map((item, index) => <li key={index} className="flex items-center gap-3" data-id="element-71">
                    <CheckIcon className="w-4 h-4 text-slate-500 flex-shrink-0" data-id="element-72" />
                    <span data-id="element-73">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}